import $foreign from "./foreign.cjs";
var getCheckboxChecked = $foreign.getCheckboxChecked;
var getTextInputValue = $foreign.getTextInputValue;
var setCheckboxChecked = $foreign.setCheckboxChecked;
var setTextInputValue = $foreign.setTextInputValue;
export { getCheckboxChecked, getTextInputValue, setCheckboxChecked, setTextInputValue };
